import { AddressInfoItem } from "./AddressInfoItem";

export default AddressInfoItem;

